/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-assignment -- This file is special */
import { types, getEnv, getPathParts, getType, getPath } from 'mobx-state-tree'

import { createSafeEnvironmentProxy } from '../createSafeEnvironmentProxy'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type -- Inferred from types
export const makeEnvironmentModel = <Environment>(name: string) =>
  types
    .model('EnvironmentModel')
    .views((self) => ({
      get globalEnvironment() {
        return createSafeEnvironmentProxy<Environment>(getEnv(self), 'MST global environment')
      },
      get modelName() {
        return getType(self).name
      },
    }))
    .views((self) => ({
      get relativeEnvironment() {
        const { globalEnvironment } = self
        const currentStorePathParts = getPathParts(self)
        const errorMessage = `Error traversing global environment when trying to access ${getPath(self)} environment`
        try {
          const currentStoreEnvironment = currentStorePathParts.reduce(
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return -- We're inside a try block
            (envNode, pathPart) => envNode[pathPart],
            globalEnvironment as any,
          )
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- On purpose
          if (!currentStoreEnvironment) {
            throw Error(errorMessage)
          }
          return currentStoreEnvironment as Environment
        } catch (ex) {
          console.warn(errorMessage, {
            globalEnvironment,
            currentStorePathParts,
            self,
            ex,
          })
          throw Error(errorMessage)
        }
      },
    }))
    .named(name)
